// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"41e40615","667":"9bf5984c","977":"289b57d4"}[chunkId] + ".chunk.js";
};